import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Is Rust the next gen C/C++? let's get some readings and keep notes...`}</p>
    <h1>{`Why? Rust?`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Performance🐾 and Security🐟, I want both!`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://benchmarksgame-team.pages.debian.net/benchmarksgame/which-programs-are-fastest.html"
      }}>{`Perform like C++`}</a>{` yet "secure" like a script lang. Talks like a cool script lang yet powerful enough to go deep down to system level. `}</p>
    <p>{`As a more secure and yet efficient lang, Rust recently catches my eyes and `}<a parentName="p" {...{
        "href": "https://hub.packtpub.com/rust-as-a-game-programming-language-is-it-any-good/"
      }}>{`some people`}</a>{` even believe it can replace (at least somewhat) the long-live C++ for game dev. Although lang itself is not the one to blame for messy/buggy C++ game code (e.g. Cyberpunk 2077), I still wish there is a cleaner/stricter language to branch from C++ (instead of splicing tons of historical/back-compatible features) so that developer doesn't need to create their own code standard, wheels, memory model etc. Junior developers under C++ tends to depise such rules which potentially leading to hard-to-find bugs like dangling pointer, memory tampering, multithread resource sharing with unclear ownership etc.. Rust uses stricter compiling check (historically strict ownership) to make sure a more reliable run time code, which means like a good human language teacher who requires you to elaborate your every sentence (and it might slow you down at first). A lot of system level cli app I used are written by Rust. After my reading, I believe knowing rust can help foster lots of good C++ habits that C++ junior won't have when first diving to C++ project. Learning Rust could be the fastest way to know how to be a better C++ coder. Besides, like other mainstream langs, Rust has friendly pkg manager 👍(cargo and crates.io). It's definitely another level to old C/C++ pkg eco-sys. Enthusiastic people even consider using it to build safer `}<a parentName="p" {...{
        "href": "https://doc.redox-os.org/book/ch01-02-what-is-redox.html"
      }}>{`OS`}</a>{`! In web world, Rust is also modern and mutually first class to webassembly, if you believe wasm is the future web.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "Rust Fast",
      "src": "https://benchmarksgame-team.pages.debian.net/benchmarksgame/download/fastest.svg"
    }}></img>
    <p>{`In my pov, Rust does the right balance between safety and efficiency. C++ can do that but requires trained and discipline programmers. The question will be down to whether extra 2% perf gain worth the trade-off. Besides how about pkg manager? Does C++ give you that by default?`}</p>
    <img {...{
      "src": "https://media.nature.com/lw800/magazine-assets/d41586-020-03382-2/d41586-020-03382-2_18629102.png",
      "alt": "Rust Popular"
    }}></img>
    <h1>{`Cheatsheet for C++ Programmer`}</h1>
    <p>{`I'm a C++ programmer, so this is for myself to revisit when forget:`}</p>
    <ul>
      <li parentName="ul">{`& is stack ptr but with safer read/write + null guarantee (reference_wrapper) and can be unsafely rawed to C++ ptr`}</li>
      <li parentName="ul">{`borrowing means better referencing (respect ownership). passing value == giveup ownership unless you has trait copy/movable (e.g. primitive type, &T, struct); passing ref only allows multiple immutable or 1 mutable`}</li>
      <li parentName="ul">{`copy is never deep (== c++ default assignment) unless you explicitly do clone`}</li>
      <li parentName="ul">{`str == C++ char[] + better boundary (than 0); String == C++ std::string; `}{`[T;usize]`}{` == C++ T[]; Vec<T`}{`>`}{` == C++ std::vector;`}</li>
      <li parentName="ul">{`&str is the common arguments for String and str, and similar for other pairs like [] & Vec`}</li>
      <li parentName="ul">{`const == C++ macro or const; static == C++ static`}</li>
      <li parentName="ul">{`smart pointers is referece with ownership more like C++. see `}<a parentName="li" {...{
          "href": "#smart_pointers"
        }}>{`table from RIA books`}</a></li>
      <li parentName="ul">{`smart pointers trait DeRef/Drop`}</li>
      <li parentName="ul">{`homework or before you consider using it as an interview lang: implement simple link list using Rust (ref `}<a parentName="li" {...{
          "href": "https://rust-unofficial.github.io/too-many-lists/second-option.html"
        }}>{`https://rust-unofficial.github.io/too-many-lists/second-option.html`}</a>{`)`}</li>
    </ul>
    <h1><a parentName="h1" {...{
        "href": "https://doc.rust-lang.org/book/title-page.html"
      }}>{`The Official Book`}</a>{` (⭐⭐⭐⭐⭐)`}</h1>
    <p>{`Nice example based learning see `}<a parentName="p" {...{
        "href": "https://doc.rust-lang.org/rust-by-example/"
      }}>{`here`}</a></p>
    <h2>{`Data Types`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "rust"
    }}><pre parentName="div" {...{
        "className": "language-rust"
      }}><code parentName="pre" {...{
          "className": "language-rust"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`i8`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i16`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i64`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i128`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`isize`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`u8`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`u16`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`u32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`u64`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`u128`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`usize`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`f32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`f64`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`char`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`unicode `}<span parentName="code" {...{
            "className": "token number"
          }}>{`4`}</span>{` bytes`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//b"..." is bytes[u8] and only ascii "..." is str type`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`bool`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` empty tuple
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`struct`}</span>{` `}<span parentName="code" {...{
            "className": "token type-definition class-name"
          }}>{`Tensor`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//tuple`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`struct`}</span>{` `}<span parentName="code" {...{
            "className": "token type-definition class-name"
          }}>{`Point`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
x`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` y`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`enum`}</span>{` `}<span parentName="code" {...{
            "className": "token type-definition class-name"
          }}>{`PointType`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`OneDimension`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// default 0 but can be =1`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`TwoDimension`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token class-name"
          }}>{`Ojb`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`ThreeDimension`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//enum`}</span>{`

`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token class-name"
          }}>{`T`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` length`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//array`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token constant"
          }}>{`COMPILE_TIME_VALUE`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`10`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`static`}</span>{` `}<span parentName="code" {...{
            "className": "token constant"
          }}>{`STATIC_VALUE`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`str`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token lifetime-annotation symbol"
          }}>{`'Unsafe`}</span>{`'`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// unsafe if you mut it`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`let`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`mut`}</span>{` mutable `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//can change but you can let mutable = mutable; to unmut it 😄`}</span></code></pre></div>
    <ul>
      <li parentName="ul">{`Immutable variable vs const: const is compile time (c++ const) while immutable is for runtime. You can mut immutable vars.`}</li>
      <li parentName="ul">{`You can shadow immutable vars but shadowing different type cannot happens`}</li>
      <li parentName="ul">{`arch type like isize and usize is depending on pc arch used`}</li>
      <li parentName="ul">{`overflow handling is suggested as wrapping`}<em parentName="li">{`* (mod) , checked`}</em><em parentName="li">{` (-> None if overflow) overflowing_`}</em>{` (->(val, boolean)) and saturating_`}<em parentName="li">{` (clamp at min/max) (`}</em>{` can be add/substract etc.) See rust makes junior aware these issues instead of hiding like c/c++!!!`}</li>
      <li parentName="ul">{`char is 4byte`}</li>
      <li parentName="ul">{`tuple let a = (1,2.0,'a') and a.0 is 1 and destructing like let (x, y, z) = a`}</li>
      <li parentName="ul">{`arrays is familiar c++/c flavor, compile time length on stack let a = `}{`[3; 5]`}{`. Out of index is protected (no invalid memory access) by rust in run time.`}</li>
    </ul>
    <h2>{`Functions`}</h2>
    <ul>
      <li parentName="ul">{`snake_case convention. `}</li>
      <li parentName="ul">{`statement doesn't return: let x = let y = 5 or let x = y = 5 is invalid. See rust kill these brain teaser statement👍.`}</li>
    </ul>
    <h2>{`Flow`}</h2>
    <ul>
      <li parentName="ul">{`if condition must be bool. Because a lot of implicit bool in other lang brings a lot of monsters. as expression let x = if con {1} else {2}; is valid as long as type is the same`}</li>
      <li parentName="ul">{`loop with break as expression let x = loop { ... break 2 };`}</li>
      <li parentName="ul">{`for n in nums.iter() or for n in (1..4)`}</li>
    </ul>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "rust"
    }}><pre parentName="div" {...{
        "className": "language-rust"
      }}><code parentName="pre" {...{
          "className": "language-rust"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` x `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..=`}</span>{`n `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`match`}</span>{` number `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token number"
          }}>{`1`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token macro property"
          }}>{`println!`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"One!"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`5`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`7`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`|`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`11`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token macro property"
          }}>{`println!`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"This is a prime"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token number"
          }}>{`13`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`..=`}</span><span parentName="code" {...{
            "className": "token number"
          }}>{`19`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token macro property"
          }}>{`println!`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"A teen"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    _ `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token macro property"
          }}>{`println!`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"Ain't special"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h2>{`Ownership`}</h2>
    <p>{`Unique features to enforce memory allocation awareness and foster good habits. Rust want to be as powerful as c/c++ to take advantage of different memory models!`}</p>
    <ul>
      <li parentName="ul">{`scope c/c++ similar RAII`}</li>
      <li parentName="ul">{`str expression e.g. "hell,world" -> c style static/global; str -> c style string in stack; String -> c++ std::string in heap`}</li>
      <li parentName="ul">{`all primitives on stack follow the similar pattern because they have Copy trait. When you do assignment Rust will never automatically create “deep” copies. Rust choose to transfer ownership and invalidate the previous owner unless you impl Copy.`}</li>
      <li parentName="ul">{`let s = "hello" and s is &str with Copy trait so it can copy/assignment but it points to the same stack location. However, fixed len array is not reusing memory, instead it just Copy around like struct.`}</li>
      <li parentName="ul">{`Tuple has copy if all its field has`}</li>
      <li parentName="ul">{`mutable references have one big restriction: you can have only one mutable reference to a particular piece of data in a particular scope and we cannot borrow mutable ref if an immutable ref was created and used later; to sum up, as long as there's mutable ref, other immutable ref shouldn't exist!!!`}</li>
      <li parentName="ul">{`let slice = &s`}{`[0..5]`}{` , &s`}{`[..5]`}{` or &`}{`[2..]`}{` to refer to chunk of bytes`}</li>
    </ul>
    <h2>{`Struct & Enum`}</h2>
    <ul>
      <li parentName="ul">{`let user2 = User { email, ..user };`}</li>
      <li parentName="ul">{`reference field will be checked to force you specify lifetime`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(Debug)]`}</code>{` macros annotates print gen for `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{:?}`}</code></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(PartialEq)]`}</code>{`:  == (all field eq) and != gen; Eq is PartialEq with one more check (a == a) so usually is marker behind like `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(PartialEq, Eq)]`}</code>{`; HashMap<K, V`}{`>`}{` requires Eq`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(PartialOrd)]`}</code>{`: require PartialEq implemented, partial_cmp -> Option<Ordering`}{`>`}{` (None, Less, Equal, Greater)`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(Clone, Copy)]`}</code>{`: clone requires all implement clone, copy is fastly shallow copy on stack with (copy requires clone)`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(Hash)]`}</code>{`: hash get hash value`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`[#derive(Default)]`}</code>{`: default make default values required by ..._or_default functions`}</li>
      <li parentName="ul">{`enum Option<T`}{`>`}{` { Some(T), None } and its functions: is_none, as_ref, as_mut, unwrap(_or), map(_or), ok(_or)->Result<T, E`}{`>`}{` ...`}</li>
    </ul>
    <h2>{`Mod`}</h2>
    <ul>
      <li parentName="ul">{`mod == namespace`}</li>
      <li parentName="ul">{`pub == public or export`}</li>
      <li parentName="ul">{`wildcard '*' and 'as'`}</li>
    </ul>
    <h2>{`Collections`}</h2>
    <h3>{`Vec`}</h3>
    <ul>
      <li parentName="ul">{`std::vec::Vec`}</li>
      <li parentName="ul">{`let v:Vec<i32`}{`>`}{` = Vec::new(); or vec`}{`![1, 2, 3]`}{` vs arrays let a:`}{`[u8;5]`}{` = `}{`[1;5]`}{`;`}</li>
      <li parentName="ul">{`immutable borrow will fail the mutable borrow`}</li>
      <li parentName="ul">{`fixed len: `}{`[i32;3]`}{` vs slices: &`}{`[usize]`}{` vs vec: Vec<i32`}{`>`}{`, use slice as function parameters is recommended`}</li>
      <li parentName="ul">{`for x in v.iter() or &v`}</li>
      <li parentName="ul">{`common methods: len, is`}<em parentName="li">{`empty, push/pop, append/split_off, dedup, clear, reserve/with_capacity, insert/remove, resize, splice, as`}</em>{`((mut_)slice/ptr), iter/&, get/[]`}</li>
      <li parentName="ul">{`Deref methods for binary search etc. like c++ container common`}</li>
    </ul>
    <h3>{`String`}</h3>
    <ul>
      <li parentName="ul">{`std::string::String`}</li>
      <li parentName="ul">{`String vs str and Rust also has the real things: CString vs CStr`}</li>
      <li parentName="ul">{`String::from("...") vs "...".to_string`}</li>
      <li parentName="ul">{`Since the interexchange of 2 types usually happens, it's recommended to make function arguments as slices: &str`}</li>
      <li parentName="ul">{`common methods for both String/str: len, push(`}<em parentName="li">{`str)/pop, from(_utf8_lossy), insert(_str)/remove, clear, is_empty, split(_off), as(into)`}</em>{`(bytes/str), replace_range, find`}</li>
    </ul>
    <h3>{`HashMap`}</h3>
    <ul>
      <li parentName="ul">{`std::collections::HashMap`}</li>
      <li parentName="ul">{`Key Eq trait is requied`}</li>
      <li parentName="ul">{`commond methods: insert/remove, get, entry(.or_insert), contains_key`}</li>
      <li parentName="ul">{`default rust hash is encryptically secure for some attack but slow, to perform better bring your own hasher`}</li>
    </ul>
    <h3>{`BTreeMap`}</h3>
    <h2>{`Error Handling`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "rust"
    }}><pre parentName="div" {...{
        "className": "language-rust"
      }}><code parentName="pre" {...{
          "className": "language-rust"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`enum`}</span>{` `}<span parentName="code" {...{
            "className": "token type-definition class-name"
          }}>{`Result`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token class-name"
          }}>{`T`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`E`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Ok`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token class-name"
          }}>{`T`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Err`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token class-name"
          }}>{`E`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <ul>
      <li parentName="ul">{`panic!, Result (unwrap/expect to panic) or ? (return/propagate error Result)`}</li>
    </ul>
    <h2>{`Generic & Lifetime`}</h2>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "rust"
    }}><pre parentName="div" {...{
        "className": "language-rust"
      }}><code parentName="pre" {...{
          "className": "language-rust"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`pub`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`trait`}</span>{` `}<span parentName="code" {...{
            "className": "token type-definition class-name"
          }}>{`Summary`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`pub`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`fn`}</span>{` `}<span parentName="code" {...{
            "className": "token function-definition function"
          }}>{`summarize`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`&`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`self`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`->`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`String`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`impl`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Summary`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Book`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`impl`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Summary`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Article`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <ul>
      <li parentName="ul">{`equivalent to C++ template`}</li>
      <li parentName="ul">{`trait == interface`}</li>
      <li parentName="ul">{`fn notify(& impl Summary) == fn notify<T:Summary`}{`>`}{`(&T)`}</li>
      <li parentName="ul">{`use + for multiple traits: fn notify(& impl Summary + Display)`}</li>
      <li parentName="ul">{`use where to clearer signature`}</li>
      <li parentName="ul">{`impl<T:SomeTrait`}{`>`}{` Summary<T`}{`>`}{` for T to define generic impl (blanked impl)`}</li>
      <li parentName="ul">{`lifetime will be smaller of your variables associated e.g. `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`'a`}</code></li>
      <li parentName="ul">{`elision rule: 1. each param has lifetime var 2. if one param return is the same 3. else if one param is &self/&mut self, &self lifetime is assigned else compiler fails to figure out and error!`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`'static`}</code>{` life time is global/static`}</li>
    </ul>
    <h2>{`Hands On!`}</h2>
    <h2></h2>
    <h1>{`Rust In Action (MEAP) (⭐⭐⭐⭐) `}<a parentName="h1" {...{
        "href": "https://rust-lang-nursery.github.io/rust-cookbook/intro.html"
      }}>{`Rust Cook Book`}</a>{` `}<a parentName="h1" {...{
        "href": "https://doc.rust-lang.org/nomicon/index.html"
      }}>{`Rust Dark Art`}</a></h1>
    <p>{`Expected to find some lang system level explanation (e.g. virtual function table, garbage collector mechanism) instead of common lang features. Also multi-threading is great topic if it can cover. `}</p>
    <h2>{`Intros`}</h2>
    <h3>{`Number Type`}</h3>
    <ul>
      <li parentName="ul">{`Conversion is explicit through `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`as`}</code></li>
      <li parentName="ul">{`Each type has its method like `}<em parentName="li">{`24.5_f32`}</em>{`.`}<code parentName="li" {...{
          "className": "language-text"
        }}>{`round()`}</code>{` is method to round `}<em parentName="li">{`24.5_f32`}</em>{` to `}<em parentName="li">{`25`}</em>{`.`}</li>
      <li parentName="ul">{`Format type "{:b}{:o}{:x}". `}</li>
      <li parentName="ul">{`Float comparison is tolerate with e.g. `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`f32::EPSILON`}</code>{`.`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`num`}</code>{` crate extend primitive types to support e.g. complex, big integer/infinite float, fixed point currency decimal`}</li>
    </ul>
    <h3>{`Iteration`}</h3>
    <ul>
      <li parentName="ul">{`for x in 0..10 `}</li>
      <li parentName="ul">{`for x in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`collection.iter()`}</code>{` or `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`&collection`}</code></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`iter_mut`}</code>{` is mutable while `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`into_iter`}</code>{` is value typed`}</li>
    </ul>
    <h3>{`Flow`}</h3>
    <ul>
      <li parentName="ul">{`loop { if ... break }`}</li>
      <li parentName="ul">{`match `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`0..=40`}</code>{` is range of `}{`[0, 40]`}{`, `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`|`}</code>{` is or and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`_`}</code>{` is otherwise`}</li>
    </ul>
    <h3>{`Function Signature`}</h3>
    <ul>
      <li parentName="ul">{`fn lifetime<'a, 'b>(x: &'a i32, y: &' i32) -> i32`}</li>
      <li parentName="ul">{`fn add<T: std::ops::Add<Output=T> + std::ops::Multiply >`}</li>
      <li parentName="ul">{`str -> c style stack/static ; String -> std::string heap and I `}<em parentName="li">{`guess`}</em>{` primitive follow the same pattern vs Box.`}</li>
      <li parentName="ul">{`Arrays -> c style Slice -> new/malloc Vector -> c++ vec`}</li>
      <li parentName="ul">{`#`}{`![allow(unused_variables)]`}{` #`}{`![allow(dead_code)]`}{` and unimplemnted! macro`}</li>
    </ul>
    <h3>{`Struct`}</h3>
    <ul>
      <li parentName="ul">{`tuple Example(i32,...) is anonymous struct and reference element by .0 .1 .2 ...`}</li>
      <li parentName="ul">{`name: String == `}{`[u8; name.size ]`}{` and data: Vec<u8`}{`>`}{` == `}{`[u8; data.size]`}{` and they are most possibly on heap`}</li>
      <li parentName="ul">{`impl, self and return (default last one, note `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`;`}</code>{`) `}</li>
    </ul>
    <h3>{`Implementation`}</h3>
    <ul>
      <li parentName="ul">{`unsafe block is used when check global in system level programming, and static globals are all capital`}</li>
      <li parentName="ul">{`panic! to throw exception`}</li>
      <li parentName="ul">{`const vs let: const is like c/c++ `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`const`}</code>{` during compile time and define fixed array while `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`let`}</code>{` is runtime. `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`let`}</code>{` is more of shared reference and it can be shadowed and convert to mut.`}</li>
      <li parentName="ul">{`Result<T, String> -> Ok(T) or Err(String) and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`unwrap()`}</code></li>
      <li parentName="ul">{`trait ... fn(self &Self ...) and impl SomeTrait for YourClass. It's like interface and implements/extend`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`#[derive(Debug)]`}</code>{` is for auto trait generation and format as {:?}`}</li>
      <li parentName="ul">{`pub as export, pub module can be pub(crate) in crate, pub(super) to parent pub(in path) to modules in path`}</li>
      <li parentName="ul">{`//! for modules/files /// for next code and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`rustdoc`}</code>{` to render the documents`}</li>
    </ul>
    <h2>{`Lifetime, Ownership & Borrowing`}</h2>
    <ul>
      <li parentName="ul">{`Copy trait is not implement unless primitive type. Assigning value leads ownership transfer. Not convenient but this avoid c/c++ copy/move constructor assumption issue (make things clear).`}</li>
      <li parentName="ul">{`Drop is extra customized destructor traits that run with default one in case you want to do some extras`}</li>
      <li parentName="ul">{`Ownership moves through: assignment including function arguments/returns. Tracing these ownership relief garbage collecting burden.`}</li>
      <li parentName="ul">{`Copy vs Clone: Copy happens at assignment or ownership transfer, all primitive type implements this; Clone is clone trait. You can use compiler to generate bit by bit (shallow) copy/clone #`}{`[derive(Debug,Clone,Copy)]`}{`.`}</li>
      <li parentName="ul">{`use std::rc::Rc is std::shared_ptr, Rc is immutable, however RefCell<T`}{`>`}{` can wrap it to make struct internal mutable via `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.borrow_mut()`}</code>{`. Note these 2 are `}<strong parentName="li">{`not`}</strong>{` threadsafe, while Arc<Mutex<T`}{`>`}{`>`}{` is.`}</li>
      <li parentName="ul">{`raw memory interprets: unsafe { std::mem::transmute(a) };`}</li>
    </ul>
    <h1>{`Integer`}</h1>
    <ul>
      <li parentName="ul">{`Integer overflow, big/little endian, f32 ieee format and Q7 format (new to me). In these case, try to use function like checked`}<em parentName="li">{`*(add) or overflow`}</em>{`*`}</li>
      <li parentName="ul">{`bit op: 1u32 << 1`}</li>
      <li parentName="ul">{`mod similar to namespace, mod.rs is for folder.`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`#[cfg(test)]`}</code>{` and cargo test`}</li>
    </ul>
    <h1>{`Pointer vs Reference`}</h1>
    <ul>
      <li parentName="ul">{`Reference is safe; pointer is unsafe: raw pointer it can be null and no check; smart pointer `}</li>
      <li parentName="ul">{`Box like java is used to box primitive types. Make them of struct flavor`}</li>
      <li parentName="ul">{`Raw pointer: let ptr = &obj as `}<em parentName="li">{` const u8 as `}</em>{`mut u8 // &reference cannot be cast directly to mut 🙂`}</li>
      <li parentName="ul">{`Cow copy on write smart pointer, if read, no copy!`}</li>
      <li parentName="ul">{`all pointers listed (note not applicable means not directly used) as below:`}</li>
    </ul>
    <div id="smart_pointers"></div>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Usage`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Pros`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`Cons`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Raw Pointer`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`&obj as `}<em parentName="td">{` const u8 as `}</em>{` mut u8`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`speed/acess other system`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`unsafe and not smart🙂`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Box<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Box<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`== c++ unique_ptr`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size overhead`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Rc<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Rc<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`== c++ shared_ptr`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/runtime cost/thread unsafe`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Arc<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`ARc<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`thread safe Rc == c++ atomic_*`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`same as Rc`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Weak<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`rc::Weak::new(..) arc::Weak::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`==c++ weak_ptr/thread safe`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/cost`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Cell<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Cell<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`unmutify obj`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/cost`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Ref(Mut)<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Ref(Mut)<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`&(mut)'s runtime version`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/cost`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`RefCell<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`RefCell<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`unmut & combine with Rc/Arc`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/cost`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Cow<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Cow:from(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`avoid clone if read`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`String::from(str)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`resizable/encoding check`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/cost`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Vec<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Vec<T`}{`>`}{`::new([])`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`resizeable`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`size/cost`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`RawVec<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`RawVec<T, A: Alloc`}{`>`}{`::new([])`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`resizeable/allocator`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`behind Vec & VecDeq, not applicable in code`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Unique<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Unique<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`used by String, Vec etc.`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`not applicable in code`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Shared<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Shared<T`}{`>`}{`::new(..)`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`used by Rc, Arc etc.`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`not applicable in code`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UnsafeCell<T`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`?`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`unsafe`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`not applicable in code`}</td>
        </tr>
      </tbody>
    </table>
    <ul>
      <li parentName="ul">{`AsRef<T`}{`>`}{` and AsMut<T`}{`>`}{` to support low cost similar to Borrow, need to pay attention to Borrow Cow ToOwned and AsRef!`}</li>
      <li parentName="ul">{`Box:new, * unary and drop -> C++ new/delete`}</li>
      <li parentName="ul">{`Trace heap: timeout 20 ltrace -T -o trace.txt -e -*+malloc+free+realloc ./target/debug/particles`}</li>
      <li parentName="ul">{`Rust can access low level system api like c/c++, e.g. winapi, kernel32`}</li>
    </ul>
    <h2>{`File & Storage`}</h2>
    <ul>
      <li parentName="ul">{`serde -> serialize/deserialize -> support json, cbor, bincode, with annotation e.g. #`}{`[derive(Serialize, Deserialize)]`}</li>
      <li parentName="ul">{`let a = br#"...."#; //multiline string format as bytes`}</li>
      <li parentName="ul">{`unwrap->expect("error message")`}</li>
      <li parentName="ul">{`OpenOptions::new().read(true).write(true).create(true)... Java flavor builder for options`}</li>
      <li parentName="ul">{`Path and PathBuf`}</li>
      <li parentName="ul">{`#`}{`[cfg(target_os="linux")]`}{` -> ifdef `}<strong parentName="li">{`LINUX`}</strong></li>
      <li parentName="ul">{`? for std Result handling, Ok-> unwrap Err-> return`}</li>
      <li parentName="ul">{`Riak and Bitcask db (guarantee never lost data)`}</li>
    </ul>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`Fixed-width header      Variable-length body
-----------------    --------------------------
/                \\ /                            \\
+=====+=====+=====+====== - - +============= - - +
| u32 | u32 | u32 | [u8]      | [u8]             |
+=====+=====+=====+====== - - +============= - - +
chksum klen  vlen   key         value`}</code></pre></div>
    <ul>
      <li parentName="ul">{`HashMap .insert []==.index() .get()`}</li>
      <li parentName="ul">{`json!("{..json..format}") from serde_json`}</li>
    </ul>
    <h2>{`Networking`}</h2>
    <ul>
      <li parentName="ul">{`reqwest::get(url)->Result<(), Box<dyn std::error::Error`}{`>`}{`>`}</li>
      <li parentName="ul">{`traits/abstract`}</li>
    </ul>
    <h3>{`impl to attach fn`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "rust"
    }}><pre parentName="div" {...{
        "className": "language-rust"
      }}><code parentName="pre" {...{
          "className": "language-rust"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`impl`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Abstract`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`fn`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`...`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h3>{`type conversion`}</h3>
    <p>{`Require impl the traits if you convert e.g. &str -> String`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "rust"
    }}><pre parentName="div" {...{
        "className": "language-rust"
      }}><code parentName="pre" {...{
          "className": "language-rust"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`impl`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`From`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`for`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Number`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//TryFrom is the fallible equivalent`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`fn`}</span>{` `}<span parentName="code" {...{
            "className": "token function-definition function"
          }}>{`from`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`s`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`i32`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`->`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`Self`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`Number`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` value`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` s `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      